module.exports = __webpack_public_path__ + "img/SD-WAN.e4b2bdf2.png";